import { ALTERAR_REGISTROS_POR_PAGINA_TOMADORES } from '../../types'

export default function alterarRegistrosPorPaginaTomadores(valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_TOMADORES,
    payload: valor
  }
}
